import { FilterQuery, SortOrder } from "mongoose";

export interface DeviceHistorySearchDto {
	query: FilterQuery<DeviceHistory>;
	sort: Record<string, SortOrder>;
	offset: number;
	limit: number;
	timestampRange: { from: number; end: number };
}

export enum CabinetState {
	OPEN = "open",
	CLOSED = "closed",
}

export enum MainVoltageState {
	OFF = "off",
	ON = "on",
}

export interface DeviceReport {
	ipAddress: string;
	online: boolean;
}

export interface DeviceHistory {
	_id: string;

	id: string;

	deviceId: string;

	permissionaryId: string;

	temperatureMeasurement: number;

	deviceReport: DeviceReport;

	voltageMeasurement: number;
	temperatureUnits: string;

	mainVoltageState: MainVoltageState;

	cabinetState: CabinetState;

	timestamp: number; //Timestamp coming in from device.

	createdAt: string;

	updatedAt: string;
}
